var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPinCurvy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 36 36",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 35.5918L27.546 26.0458C29.434 24.1577 30.7197 21.7523 31.2406 19.1335C31.7615 16.5148 31.4941 13.8004 30.4724 11.3336C29.4506 8.86682 27.7202 6.75842 25.5002 5.27503C23.2801 3.79163 20.67 2.99988 18 2.99988C15.33 2.99988 12.7199 3.79163 10.4998 5.27503C8.27976 6.75842 6.54944 8.86682 5.52765 11.3336C4.50586 13.8004 4.23851 16.5148 4.75939 19.1335C5.28028 21.7523 6.56601 24.1577 8.45401 26.0458L18 35.5918ZM18 20.9999C20.4853 20.9999 22.5 18.9852 22.5 16.4999C22.5 14.0146 20.4853 11.9999 18 11.9999C15.5147 11.9999 13.5 14.0146 13.5 16.4999C13.5 18.9852 15.5147 20.9999 18 20.9999Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinCurvy);
export default __webpack_public_path__ + "static/media/pin-curvy.32adf2b3213f4211af87f810638e4139.svg";
export { ForwardRef as ReactComponent };